import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useI18n } from "@/i18n";
import { AppLayout } from "@/components/AppLayout";
import { Input } from "@/components/ui/input";
import { BookOpen, Search, Lightbulb } from "lucide-react";

export default function Glossary() {
  const { t, lang } = useI18n();
  const [terms, setTerms] = useState([]);
  const [query, setQuery] = useState("");
  const [openIdx, setOpenIdx] = useState(null);

  useEffect(() => { api.get(`/glossary?lang=${lang}`).then((r) => setTerms(r.data)); }, [lang]);

  const filtered = terms.filter((tm) => tm.term.toLowerCase().includes(query.toLowerCase()) || (tm.simple || "").toLowerCase().includes(query.toLowerCase()));

  return (
    <AppLayout>
      <h1 className="font-display text-3xl font-semibold text-navy flex items-center gap-2"><BookOpen className="h-7 w-7 text-brandblue" /> {t("glossary")}</h1>
      <p className="mt-1 text-slate-500">{t("glossary_sub")}</p>

      <div className="mt-5 relative max-w-md">
        <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-slate-400" />
        <Input data-testid="glossary-search" value={query} onChange={(e) => setQuery(e.target.value)} placeholder={t("search_terms")} className="pl-10 rounded-full" />
      </div>

      <div className="mt-6 grid grid-cols-1 md:grid-cols-2 gap-4">
        {filtered.map((tm, i) => (
          <button key={i} data-testid={`glossary-term-${tm.term}`} onClick={() => setOpenIdx(openIdx === i ? null : i)}
            className="text-left rounded-2xl bg-white border border-slate-100 card-shadow p-5 hover:-translate-y-0.5 transition-transform">
            <div className="flex items-center justify-between">
              <h3 className="font-semibold text-navy">{tm.term}</h3>
              <span className="rounded-full bg-blue-50 px-2.5 py-0.5 text-xs font-medium text-brandblue">{tm.category}</span>
            </div>
            <p className="mt-2 text-sm text-slate-600">{tm.simple}</p>
            {openIdx === i && (
              <div className="mt-3 space-y-2 border-t border-slate-100 pt-3">
                <p className="text-sm text-slate-600"><span className="font-medium text-navy">{t("g_example")}</span>{tm.example}</p>
                <p className="text-sm text-slate-600 flex gap-1.5"><Lightbulb className="h-4 w-4 text-amber-500 shrink-0 mt-0.5" /><span><span className="font-medium text-navy">{t("g_why")}</span>{tm.why}</span></p>
              </div>
            )}
          </button>
        ))}
      </div>
    </AppLayout>
  );
}
